import { SplashScreen } from "@capacitor/splash-screen";
import "bulma-calendar/dist/css/bulma-calendar.min.css";
import "bulma-pageloader/dist/css/bulma-pageloader.min.css";
import "bulma-slider/dist/css/bulma-slider.min.css";
import "bulma-switch/dist/css/bulma-switch.min.css";
import "bulma/css/bulma.min.css";
import "material-symbols/sharp.css";
import type { Match } from "navigo";
import "nouislider/dist/nouislider.min.css";
import type { ChildDom } from "vanjs-core";
import van from "vanjs-core";
import { AdminPage } from "./admin/admin_page";
import { Api } from "./api";
import { getPrices } from "./api/prices";
import { refreshToken } from "./api/token";
import { config, initAppEnv } from "./app-env/common";
import "./css/style.css";
import { devicesPage, onLeaveDevicesPage } from "./device/devices_page";
import { registerDevicePage } from "./device/register_device_page";
import { loadConnectionErrorPage } from "./error";
import { AdminFcsPage } from "./farmcam-sim/fcs_admin_pages";
import { farmcamSimLogsPage } from "./farmcam-sim/fcs_logs_page";
import { loadFarmcamSimSettingsPage } from "./farmcam-sim/fcs_settings_page";
import { registerFarmcamSimPage } from "./farmcam-sim/register_fcs_page";
import { adminFaPage } from "./fencealarm/fa_admin_pages";
import { fencealarmLogsPage } from "./fencealarm/fa_logs_page";
import { fencealarmSettingsPage } from "./fencealarm/fa_settings_page";
import { registerFencealarmPage } from "./fencealarm/register_fa_page";
import { adminFa2Page } from "./fencealarm2/fa2_admin_pages";
import { fencealarm2LogsPage } from "./fencealarm2/fa2_logs_page";
import { fencealarm2SettingsPage } from "./fencealarm2/fa2_settings_page";
import { registerFencealarm2Page } from "./fencealarm2/register_fa2_page";
import { locale } from "./locale";
import {
	getInitialNotification,
	MobileFlags,
	onAndroid,
	onMobile,
	startNotificationListeners,
	startStateListener,
} from "./mobile";
import { loadNoticesPage } from "./notices/notices_admin_page";
import { noticesSection } from "./notices/notices_section";
import { Router } from "./router";
import { registerSmartplugPage } from "./smartplug/register_sp_page";
import { AdminSpPage } from "./smartplug/sp_admin_pages";
import { smartplugLogsPage } from "./smartplug/sp_logs_page";
import { smartplugSettingsPage } from "./smartplug/sp_settings_page";
import { Sp2AdminPage } from "./smartplug2/sp2_admin_page";
import { Sp2CmdGetFwPage } from "./smartplug2/sp2_cmd_get_fw_page";
import { Sp2CmdGetImsiPage } from "./smartplug2/sp2_cmd_get_imsi_page";
import { Sp2CmdGetStatusPage } from "./smartplug2/sp2_cmd_get_status_page";
import { Sp2CmdSetBeepPage } from "./smartplug2/sp2_cmd_set_beep_page";
import { Sp2CmdSetFwPage } from "./smartplug2/sp2_cmd_set_fw_page";
import { Sp2CmdSetLoadAlarmPage } from "./smartplug2/sp2_cmd_set_load_alarm_page";
import { Sp2CmdSetOutputPowerPage } from "./smartplug2/sp2_cmd_set_output_power_page";
import { Sp2CmdsPage } from "./smartplug2/sp2_cmds_page";
import { Sp2FactoryPage } from "./smartplug2/sp2_factory_page";
import { Sp2FactoryResetPage } from "./smartplug2/sp2_factory_reset_page";
import { Sp2FotaPage } from "./smartplug2/sp2_fota_page";
import { Sp2LogsPage } from "./smartplug2/sp2_logs_page";
import { Sp2ProvisioningPage } from "./smartplug2/sp2_provisioning_page";
import { registerSmartplug2Page } from "./smartplug2/sp2_registration_page";
import { Sp2SettingsPage } from "./smartplug2/sp2_settings_page";
import { state } from "./state";
import { AccountPage } from "./user/account_page";
import { DeleteAccountPage } from "./user/confirm_account_deletion_page";
import { PurchaseSmsPage } from "./user/confirm_sms_purchase_page";
import { createAccountPage } from "./user/create-account";
import { resetPasswordPage } from "./user/reset_password_page";
import { signInPage } from "./user/sign_in_page";
import {
	adminFindUserPage,
	adminInspectUserPage,
} from "./user/user_admin_pages";
import { verifyEmailPage } from "./user/verify_email_page";
import { warrantyPage } from "./user/warranty_page";
import { delay } from "./utils";
import { ErrorSection } from "./van/error-section";
import { LoadingScreen } from "./van/loading-screen";
import { Bulma } from "./view/bulma";
import { navbar } from "./view/navbar";
import { notFoundPage } from "./view/not_found_page";
import { redirectPage } from "./view/redirect_page";

initAppEnv();

const appContainer = document.createElement("div");
appContainer.className = "app-container";
if (onAndroid) appContainer.classList.add("is-android");

const loadingScreen = document.createElement("div");
loadingScreen.className = "pageloader is-active";

const error = new ErrorSection();

const modal = Bulma.modalCard();

const loadingScreen2 = new LoadingScreen();

van.add(
	document.body,
	appContainer,
	error.ChildDom,
	loadingScreen,
	modal.element,
	loadingScreen2.ChildDom,
);

const router = new Router({
	notFoundHandler: notFoundPage,
	mountRoute: setPageContent,
	rootPath: "/",
});

router.routeContext = {
	api: new Api(config.apiHost, () => router.jump("/connection-error")),
	error: error,
	loadingScreen: loadingScreen2,
	router: router,
	sp2gw: new Api(config.sp2gwHost, () => router.jump("/connection-error")),
};

router.registerRoute("/account", AccountPage);
router.registerRoute("/account/buy-sms", PurchaseSmsPage);
router.registerRoute("/account/delete", DeleteAccountPage);
router.registerRoute("/admin", AdminPage);
router.registerRoute("/admin/farmcam-sim/:imsi", AdminFcsPage);
router.registerRouteDEPRECATED("/admin/fencealarm/:imei", handler(adminFaPage));
router.registerRouteDEPRECATED(
	"/admin/fencealarm2/:imei",
	handler(adminFa2Page),
);
router.registerRouteDEPRECATED("/admin/notices", loadNoticesPage);
router.registerRoute("/admin/smartplug/:imei", AdminSpPage);
router.registerRoute("/admin/smartplug2/:imei", Sp2AdminPage);
router.registerRoute(
	"/admin/smartplug2/:imei/factory-reset",
	Sp2FactoryResetPage,
);
router.registerRoute("/admin/smartplug2/:imei/fota", Sp2FotaPage);
router.registerRouteDEPRECATED("/admin/user", handler(adminFindUserPage));
router.registerRouteDEPRECATED(
	"/admin/user/:id",
	handler(adminInspectUserPage),
);
router.registerRouteDEPRECATED("/connection-error", loadConnectionErrorPage);
router.registerRouteDEPRECATED("/create-account", createAccountPage);
router.registerRouteDEPRECATED("/devices", devicesPage, {
	leave: onLeaveDevicesPage,
});
router.registerRouteDEPRECATED("/devices/register", registerDevicePage);
router.registerRouteDEPRECATED(
	"/devices/register/farmcam-sim",
	registerFarmcamSimPage,
);
router.registerRouteDEPRECATED(
	"/devices/register/fencealarm",
	registerFencealarmPage,
);
router.registerRouteDEPRECATED(
	"/devices/register/fencealarm2",
	registerFencealarm2Page,
);
router.registerRouteDEPRECATED(
	"/devices/register/smartplug",
	registerSmartplugPage,
);
router.registerRouteDEPRECATED(
	"/devices/register/smartplug2",
	registerSmartplug2Page,
);
router.registerRoute("/factory/smartplug2", Sp2FactoryPage);
router.registerRoute("/factory/smartplug2/:imei/commands", Sp2CmdsPage);
router.registerRoute(
	"/factory/smartplug2/:imei/commands/get-fw",
	Sp2CmdGetFwPage,
);
router.registerRoute(
	"/factory/smartplug2/:imei/commands/get-imsi",
	Sp2CmdGetImsiPage,
);
router.registerRoute(
	"/factory/smartplug2/:imei/commands/get-status",
	Sp2CmdGetStatusPage,
);
router.registerRoute(
	"/factory/smartplug2/:imei/commands/set-beep",
	Sp2CmdSetBeepPage,
);
router.registerRoute(
	"/factory/smartplug2/:imei/commands/set-fw",
	Sp2CmdSetFwPage,
);
router.registerRoute(
	"/factory/smartplug2/:imei/commands/set-load-alarm",
	Sp2CmdSetLoadAlarmPage,
);
router.registerRoute(
	"/factory/smartplug2/:imei/commands/set-output-power",
	Sp2CmdSetOutputPowerPage,
);
router.registerRoute(
	"/factory/smartplug2/:imei/provision",
	Sp2ProvisioningPage,
);
router.registerRouteDEPRECATED(
	"/farmcam-sim/:imsi",
	loadFarmcamSimSettingsPage,
);
router.registerRouteDEPRECATED("/farmcam-sim/:imsi/logs", farmcamSimLogsPage);
router.registerRouteDEPRECATED("/fencealarm/:imei", fencealarmSettingsPage);
router.registerRouteDEPRECATED("/fencealarm/:imei/logs", fencealarmLogsPage);
router.registerRouteDEPRECATED("/fencealarm2/:imei", fencealarm2SettingsPage);
router.registerRouteDEPRECATED("/fencealarm2/:imei/logs", fencealarm2LogsPage);
router.registerRouteDEPRECATED("/redirect", redirectPage.mount, {
	leave: redirectPage.onUnmount,
});
router.registerRouteDEPRECATED("/reset-password", resetPasswordPage);
router.registerRouteDEPRECATED("/sign-in", signInPage);
router.registerRouteDEPRECATED("/smartplug/:imei", smartplugSettingsPage);
router.registerRouteDEPRECATED("/smartplug/:imei/logs", smartplugLogsPage);
router.registerRoute("/smartplug2/:imei", Sp2SettingsPage);
router.registerRoute("/smartplug2/:imei/logs", Sp2LogsPage);
router.registerRouteDEPRECATED("/verify-account", verifyEmailPage);
router.registerRouteDEPRECATED("/warranties", handler(warrantyPage));

init();

function hideLoadingScreen(): void {
	loadingScreen.classList.remove("is-active");
}

async function init(): Promise<void> {
	setTimeout(() => SplashScreen.hide(), 600);

	await locale.update();
	await startStateListener();
	if (onMobile) {
		startNotificationListeners();
		/**
		 * It takes a while for the app to pick up the initial notification which we need before
		 * before navigating to devices. This will give the notification time to load before
		 * proceeding.
		 */
		if (!MobileFlags.getValue("appFinishedLoading")) {
			// ToDo: Check if 500 ms can be decreased
			await delay(500);
		}
	}

	const preloads: Promise<unknown>[] = [getPrices()];

	MobileFlags.setValue("appFinishedLoading", true);

	if (await state.isSignedIn()) {
		preloads.push(refreshToken().then(state.loadDevices));
		switch (window.location.pathname) {
			case "/":
			case "/create-account":
			case "/devices":
			case "/reset-password":
			case "/sign-in":
			case "/verify-account": {
				const imei = getInitialNotification()?.data?.Imei;
				const user = await state.getSignedInUser();
				if (imei) {
					window.history.replaceState(
						null,
						"",
						`/devices?id=${imei}`,
					);
				} else if (user.AccountType === "smartplug2-factory") {
					window.history.replaceState(
						null,
						"",
						"/factory/smartplug2",
					);
				} else {
					window.history.replaceState(null, "", "/devices");
				}
			}
		}
	} else {
		switch (window.location.pathname) {
			case "/create-account":
			case "/reset-password":
			case "/sign-in":
			case "/smartplug2-provisioning":
			case "/verify-account":
				break;
			default:
				window.history.replaceState(null, "", "/sign-in");
		}
	}

	await Promise.all(preloads).catch(() => {
		window.history.pushState(null, "", "/connection-error");
	});

	router.resolve();
}

function showLoadingScreen(): void {
	loadingScreen.classList.add("is-active");
	modal.close();
	const job = (): void => hideLoadingScreen();
	setTimeout(job, 30000);
}

function handler(getRoot: (match: Match) => Promise<HTMLElement>) {
	return (match: Match | undefined): void => {
		if (!match) return;
		getRoot(match).then((root) => setPageContent(root));
	};
}

function setPageContent(childDom: ChildDom): void {
	const mountPageContent = async (childDom: ChildDom): Promise<void> => {
		appContainer.replaceChildren(
			await navbar(config.navbarTheme),
			await noticesSection(),
			Bulma.hero(childDom as Node),
		);
	};

	mountPageContent(childDom).finally(hideLoadingScreen);
}

export {
	appContainer,
	hideLoadingScreen,
	modal,
	router,
	setPageContent,
	showLoadingScreen,
};
